import { render } from "./events-table.component.vue?vue&type=template&id=7aab5b93"
import script from "./events-table.component.vue?vue&type=script&lang=js"
export * from "./events-table.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./events-table.component.vue?vue&type=style&index=0&id=7aab5b93&lang=css&module=true"
cssModules["$style"] = style0

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__